import { Injectable, EventEmitter } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { Observable, interval } from 'rxjs';
import { map, distinctUntilChanged } from 'rxjs/operators';
import { UserConfigService } from './userConfig.service';
import { IGetOperationResponse } from '../interfaces/IGetOperationResponse';
import { IApplicantLoginResponse } from '../interfaces/IApplicantLoginResponse';
import { DataSharingService } from './DataSharing.service';
import { TranslateService } from '@ngx-translate/core';

@Injectable({ providedIn: 'root' })
export class AppConfigService {
  private appConfig: any;
  constructor(private http: HttpClient,
    private sharedData: DataSharingService,
    private translateService: TranslateService) { }

  LoadAppConfig() {
    return this.http.get('assets/Data/appConfig.json')
      .toPromise()
      .then(data => {
        this.appConfig = data;
        this.GetUserInfo(this.appConfig.AppUrl).subscribe(
          (response: IGetOperationResponse<IApplicantLoginResponse>) => {
            //  let token = sessionStorage.getItem('Access-Token');
            //   console.log('token',token);

            if (response && response.Result) {
              this.sharedData.userName.next(this.getUserName());
              this.sharedData.isUserLoggedIn.next(response.Result.IsloggedIn);
              this.sharedData.userType.next(response.Result.UserType);
              this.sharedData.choosenModule.next(response.Result.Module);
              this.sharedData.tokenExpiryTimeValue.next(parseInt(sessionStorage.getItem("tokenCounter")));
            }
            // else if((!response||!response.Result) && token && token !== ''){
            //   location.reload();
            // }
          },
          (err) => {
          },
          () => console.log('Calling api complete'));
      });
  }
  getAppConfig() {
    return this.appConfig;
  }
  getAppConfigForCommonService(): Observable<any> {
    return interval(50).pipe(
      map(() => this.appConfig),
      distinctUntilChanged()
    );
  }

  GetUserInfo(url) {

    return this.http.get<object>(url + '/api/UserDataManager/GetUserInformation')
      .pipe(
      // catchError(this.handleError('',))
    );
  }

  getUserName(): string {
    let userName: string = "";
    if (this.translateService.currentLang == "en") {
      userName = sessionStorage.getItem("EnglishUserName");
    } else {
      userName = sessionStorage.getItem("ArabicUserName");
    }
    return userName;
  }



}
